module.exports = __webpack_public_path__ + "assets/img/discernment_gender_describe.24e19d25.png";